import type { Verdict } from './types';

export interface VerdictColor {
  bg: string;
  fg: string;
  border: string;
  accent: string;
}

// Single source of truth for verdict color logic. All components consume this.
export function verdictColor(verdict: Verdict): VerdictColor {
  switch (verdict) {
    case 'BULLISH':
      return {
        bg: 'var(--tia-positive-soft)',
        fg: 'var(--tia-positive)',
        border: 'var(--tia-positive)',
        accent: 'var(--tia-positive)',
      };
    case 'BEARISH':
      return {
        bg: 'var(--tia-negative-soft)',
        fg: 'var(--tia-negative)',
        border: 'var(--tia-negative)',
        accent: 'var(--tia-negative)',
      };
    case 'MIXED':
    default:
      return {
        bg: 'var(--tia-warning-soft)',
        fg: 'var(--tia-warning)',
        border: 'var(--tia-warning)',
        accent: 'var(--tia-warning)',
      };
  }
}

export function verdictFromScore(score: number): Verdict {
  if (score >= 0.25) return 'BULLISH';
  if (score <= -0.25) return 'BEARISH';
  return 'MIXED';
}

export function qualitativeTier(value: number): 'HIGH' | 'ELEVATED' | 'MODERATE' | 'LOW' {
  if (value >= 0.75) return 'HIGH';
  if (value >= 0.5) return 'ELEVATED';
  if (value >= 0.25) return 'MODERATE';
  return 'LOW';
}
